<div class="card-header-mini">
  <h3 class="card-title">{{widgetData.cardTitle}}</h3>
</div>

<div class="card-content-wrap">
  <div class="img-box">
    <picture class="w-100 h-auto">
      <source
        *ngIf="widgetData.mobileImageUrl"
        media="(max-width: 768px)"
        [srcset]="widgetData.mobileImageUrl + '?width=174&format=webp'"
        class="lazy"
      />
      <img
        alt="Lobby Mob"
        loading="lazy"
        class="w-100 h-auto"
        [src]="widgetData.imageUrl + '?width=549&format=webp'"
      />
    </picture>   
  </div>

  <div class="card-content-info">
    <h4 class="title">{{widgetData.title}}</h4>

    <p class="text">{{widgetData.subTitle}}</p>

    <a href="{{widgetData.url}}" class="link" target="{{widgetData.linkTarget}}">
      <span>{{widgetData.btnOpenArticleText}}</span>
    </a>
  </div>
</div>
